module.exports = __webpack_public_path__ + "static/media/special-stone.8b42e16f.svg";